import { useEffect, useState } from 'react';
import { Cloud, CloudRain, CloudSnow, Sun, CloudSun } from 'lucide-react';

interface WeatherData {
  main: {
    temp: number;
  };
  weather: Array<{
    id: number;
    main: string;
    description: string;
    icon: string;
  }>;
}

interface WeatherDisplayProps {
  lat: string;
  long: string;
}

const API_KEY = '122d8324f70815bd9c7f2577c3d6206c';

export function WeatherDisplay({ lat, long }: WeatherDisplayProps) {
  const [weather, setWeather] = useState<WeatherData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const response = await fetch(
          `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${long}&units=imperial&appid=${API_KEY}`
        );

        if (!response.ok) throw new Error('Weather data fetch failed');
        const data = await response.json();
        setWeather(data);
      } catch (error) {
        console.error('Error fetching weather:', error);
      } finally {
        setLoading(false);
      }
    };

    if (lat && long) {
      fetchWeather();
    }
  }, [lat, long]);

  if (loading || !weather) return null;

  const WeatherIcon = () => {
    const id = weather.weather[0].id;
    if (id >= 200 && id < 600) return <CloudRain className="h-3.5 w-3.5" />;
    if (id >= 600 && id < 700) return <CloudSnow className="h-3.5 w-3.5" />;
    if (id >= 700 && id < 800) return <Cloud className="h-3.5 w-3.5" />;
    if (id === 800) return <Sun className="h-3.5 w-3.5" />;
    return <CloudSun className="h-3.5 w-3.5" />;
  };

  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground bg-muted/50 px-2 py-1 rounded">
      <WeatherIcon />
      <span>{Math.round(weather.main.temp)}°F</span>
      <span className="capitalize">{weather.weather[0].description}</span>
    </div>
  );
}